// extracted by mini-css-extract-plugin
export var lightMode = "_16-0";